import React from 'react';
import { useCadastroComposicao } from '../../hook/useCadastroComposicao';
import { formatCurrencyAsText } from '~/utils/functions';

export const Footer: React.FC = () => {
  const { valorTotalComposicao, valorTotalLoja, rows } =
    useCadastroComposicao();

  return (
    <div
      style={{
        display: 'flex',
        margin: '5px 0px',
        padding: '15px',
        justifyContent: 'flex-end',
        alignItems: 'center',
        borderRadius: '5px',
        backgroundColor: '#e7f1fe',
        border: '1px solid #b8d4f1',
      }}
    >
      <h1 style={{ marginRight: '20px', fontSize: '20px' }}>
        Valor Loja: R$
        {rows.length > 0 ? formatCurrencyAsText(valorTotalLoja) : ' 0,00'}
      </h1>
      <h1 style={{ fontSize: '20px' }}>
        Valor Comp: R$
        {rows.length > 0 ? formatCurrencyAsText(valorTotalComposicao) : ' 0,00'}
      </h1>
    </div>
  );
};
